﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import { JssClass } from "~base/Styling";
import { getSize } from "~base/Components/Layout/JssSpacing";
import { adminMenu } from "~base/Components/Pages/Home/Start/Customization";
import { UserInfoCustomizations } from "~base/Components/Pages/Shared/UserInfoCard";

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// Customizations
//-------------------------------------------------------------------------------------

export interface CustomStyles {
    header?: JssClass;
    bottom?: JssClass;
    radioPadding?: JssClass;
}

export const defaultStyling = {
    header: {
        padding: `25px ${25 + getSize("HalfMedium")}px 0px ${25 + getSize("HalfMedium")}px`,
    },
    bottom: {
        display: "flex",
        flexDirection: "row-reverse",
        alignItems: "center",
        justifyContent: "space-between",
    },
};

export interface AccessDeniedPageCustomizations {
    customStyles?: CustomStyles;
    // Possibility to override the message to create variants of the AccessDeniedPage
    // e.g Forbidden. Default value "VisiFinance.UI.AccessDenied.DefaultMessage"
    errorMessageTextCode?: string;
    logoutButtonUrl?: string;
    logoutButtonTextCode?: string;
    adminMenu?: (userRole: string) => React.ReactNode;
    userInfoCustomizations?: UserInfoCustomizations;
}

export const AccessDeniedPageDefaultCustomization = {
    customStyles: defaultStyling,
    adminMenu: adminMenu,
} as AccessDeniedPageCustomizations;
